import { UserCreateCustomForm } from '../ui-components';
import { View, Button, Text } from '@aws-amplify/ui-react';
import { useState } from 'react';
import { generateClient } from 'aws-amplify/api';
import { createUser } from '../graphql/mutations';
import { useNavigate } from 'react-router-dom';
import JustAdminMessage from '../commons/JustAdminMessage';
import { createCognitoUser } from '../api/adminUsersApi';

const client = generateClient();
const ROLE_GROUPS = {
    "Administrador": "Administradores",
    "Operador": "Operadores",
    "Cliente": "Clientes"
};

function CreateProjectForm(props) {
    const [formData, setFormData] = useState();
    const [showForm, setShowForm] = useState(true);
    const [error, setError] = useState(null);

    const navigate = useNavigate();
    const handleProjectPage = () => {
        navigate("/admin")
    }

    const OnChangeForm = (fields) => {
        fields.email = fields.Field2;
        delete fields.Field2;
        setFormData(fields);
    };

    const OnValidateForm = {
        username: (value, validationResponse) => {
          const firstWord = value.split('')[0];
          if (!firstWord.match(/[a-zA-Z]/)) {
            return {
              hasError: true,
              errorMessage: 'El nombre de usuario debe comenzar con una letra'
            };
          }
          if (value.includes(" ")) {
            return {
              hasError: true,
              errorMessage: 'El nombre de usuario no debe contener espacios'
            };
          }
          return validationResponse;
        }
      };

    const OnSubmitForm = async () => {
        setError(null);
        try {
            const groupName = ROLE_GROUPS[formData.role];

            await createCognitoUser({
                username: formData.username,
                email: formData.email,
                role: groupName
            });
            console.log("User created successfully in Cognito");
            const newUser = await client.graphql({
                query: createUser,
                variables: {
                    input: {
                        'username': formData.username,
                        'email': formData.email,
                        "isAdmin": formData.role === 'Administrador' ? 'true' : 'false',
                        "role": formData.role
                    }
                }
            });

            console.log("User created successfully");
            setShowForm(false);
            return newUser;
        } catch (error) {
            console.error("Error creating user:", error);
            setError(error?.message || 'No se pudo crear el usuario.');
            return null;
        }
    };

    return (
        <>
            {props.role === 'Administrador' ? (
                <View style={formStyle} font="font.inverse">
                    {showForm ? (
                        <>
                            <h4>Create a new user</h4>
                            <UserCreateCustomForm
                                onChange={(fields) => OnChangeForm(fields)}
                                onValidate={OnValidateForm}
                                onCancel={handleProjectPage}
                                onSubmit={OnSubmitForm}
                            />
                            {error && <Text color="red">{error}</Text>}
                        </>
                    ) : (
                        <>
                            <h4>Usuario creado correctamente</h4>
                            <Text color="white">
                                Cognito enviara la invitacion al correo configurado.
                            </Text>
                            <Button
                                padding='0.5rem'
                                margin='1rem'
                                variation="primary"
                                onClick={() => { setShowForm(true); }}
                            >Crear otro usuario</Button>
                            <Button
                                padding='0.5rem'
                                margin='1rem'
                                variation="primary"
                                onClick={handleProjectPage}
                            >Usuario</Button>
                        </>
                    )}
                </View>

            ) : (
                <JustAdminMessage/>
              )}

        </>

    );
}

const formStyle = {
    // padding: '50px 20px',
    backgroundColor: '#282c34',
    padding: '1rem',
    // width: '30rem',
    height: '30rem',
    color: 'white'
};

export default CreateProjectForm;
